import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#595959",
  "fill-rule": "evenodd",
  d: "M1.5 14.667a.5.5 0 0 1 .5-.5h12a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5Z",
  "clip-rule": "evenodd",
  opacity: ".4"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#595959",
  "fill-rule": "evenodd",
  d: "M1.5 6.253c0-.642.524-1.166 1.167-1.166h1.066c.643 0 1.167.524 1.167 1.166V12c0 .643-.524 1.167-1.167 1.167H2.667A1.169 1.169 0 0 1 1.5 12V6.253Zm1.167-.166a.169.169 0 0 0-.167.166V12c0 .09.076.167.167.167h1.066c.09 0 .167-.076.167-.167V6.253a.169.169 0 0 0-.167-.166H2.667ZM6.3 4.127c0-.643.524-1.167 1.167-1.167h1.066c.643 0 1.167.524 1.167 1.167V12c0 .643-.524 1.167-1.167 1.167H7.467A1.169 1.169 0 0 1 6.3 12V4.127Zm1.167-.167a.169.169 0 0 0-.167.167V12c0 .09.076.167.167.167h1.066c.09 0 .167-.076.167-.167V4.127a.169.169 0 0 0-.167-.167H7.467ZM11.1 2c0-.643.524-1.167 1.167-1.167h1.066c.643 0 1.167.524 1.167 1.167v10c0 .643-.524 1.167-1.167 1.167h-1.066A1.169 1.169 0 0 1 11.1 12V2Zm1.167-.167A.169.169 0 0 0 12.1 2v10c0 .09.076.167.167.167h1.066c.09 0 .167-.076.167-.167V2a.169.169 0 0 0-.167-.167h-1.066Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }